import React from "react";
import { RulesContextProvider } from "../../../Components/GMS/Rules/RulesContext";
import RulesAddEditManage from "../../../Components/GMS/Rules/RulesAddEditManage";

function RulesAddEdit(props) {
  const { params } = props.match;
  return (
    <React.Fragment>
      <RulesContextProvider>
        <RulesAddEditManage ruleId={params.id} type={params?.type} />
      </RulesContextProvider>
    </React.Fragment>
  );
}

export default RulesAddEdit;
